import Phaser from 'phaser';

/** Lightweight, dependency-free "juice" helpers built from plain tweened shapes
 * rather than Phaser's particle emitter, so they work without any pre-baked
 * texture atlas and stay easy to reskin later. */

export function spawnBurst(scene: Phaser.Scene, x: number, y: number, color: number, count = 12): void {
  for (let i = 0; i < count; i++) {
    const angle = (Math.PI * 2 * i) / count + Math.random() * 0.4;
    const distance = 30 + Math.random() * 40;
    const dot = scene.add.circle(x, y, 4 + Math.random() * 3, color, 1);
    dot.setDepth(50);
    scene.tweens.add({
      targets: dot,
      x: x + Math.cos(angle) * distance,
      y: y + Math.sin(angle) * distance - 10,
      alpha: { from: 1, to: 0 },
      scale: { from: 1, to: 0.3 },
      duration: 420 + Math.random() * 160,
      ease: 'Cubic.easeOut',
      onComplete: () => dot.destroy(),
    });
  }
}

export function spawnFloatingText(
  scene: Phaser.Scene,
  x: number,
  y: number,
  text: string,
  color: string,
  fontSize = 30
): void {
  const label = scene.add
    .text(x, y, text, {
      fontFamily: "'Baloo 2', 'Comic Sans MS', system-ui, sans-serif",
      fontSize: `${fontSize}px`,
      color,
      fontStyle: '800',
      stroke: '#2b1f3d',
      strokeThickness: 5,
    })
    .setOrigin(0.5)
    .setDepth(60);

  scene.tweens.add({
    targets: label,
    y: y - 70,
    alpha: { from: 1, to: 0 },
    scale: { from: 0.7, to: 1.15 },
    duration: 620,
    ease: 'Cubic.easeOut',
    onComplete: () => label.destroy(),
  });
}

export function shakeCamera(scene: Phaser.Scene, intensity = 0.006, duration = 160): void {
  scene.cameras.main.shake(duration, intensity);
}

export function vibrate(pattern: number | number[]): void {
  if (typeof navigator !== 'undefined' && 'vibrate' in navigator) {
    try {
      navigator.vibrate(pattern);
    } catch {
      // unsupported -- ignore
    }
  }
}
